// import React from "react";

// const OfferStyleOne = () => {
//   return (
//     <section className="offer-style-one">
//       <div className="container">
//         <div className="block-title text-center">
//           <div className="dot-line"></div>
//           <p>Check out our benefits</p>
//           <h2>What we’re offering</h2>
//         </div>

//         <div className="row">
//           <div className="col-lg-4">
//             <div className="single-offer-one hvr-float-shadow">
//               <div className="image-block">
//                 <a href="#">
//                   <i className="fa fa-link"></i>
//                 </a>
//                 <img
//                   src="images/resources/offer-1-1.jpg"
//                   alt="Awesome Image"
//                 />
//               </div>

//               <div className="text-block">
//                 <h3>
//                   <a href="#">Credit booking</a>
//                 </h3>
//                 <p>
//                   There are many van of pasage of suffer alteration lipsum is
//                   simply free text.
//                 </p>
//                 <a href="#" className="more-link">
//                   Read More
//                 </a>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-4">
//             <div className="single-offer-one hvr-float-shadow">
//               <div className="image-block">
//                 <a href="#">
//                   <i className="fa fa-link"></i>
//                 </a>
//                 <img
//                   src="images/resources/offer-1-2.jpg"
//                   alt="Awesome Image"
//                 />
//               </div>

//               <div className="text-block">
//                 <h3>
//                   <a href="#">Home pickups</a>
//                 </h3>
//                 <p>
//                   There are many van of pasage of suffer alteration lipsum is
//                   simply free text.
//                 </p>
//                 <a href="#" className="more-link">
//                   Read More
//                 </a>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-4">
//             <div className="single-offer-one hvr-float-shadow">
//               <div className="image-block">
//                 <a href="#">
//                   <i className="fa fa-link"></i>
//                 </a>
//                 <img
//                   src="images/resources/offer-1-3.jpg"
//                   alt="Awesome Image"
//                 />
//               </div>

//               <div className="text-block">
//                 <h3>
//                   <a href="#">Long travels</a>
//                 </h3>
//                 <p>
//                   There are many van of pasage of suffer alteration lipsum is
//                   simply free text.
//                 </p>
//                 <a href="#" className="more-link">
//                   Read More
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default OfferStyleOne;




import React from "react";

const OfferStyleOne = () => {
  return (
    <section className="offer-style-one">
      <div className="container">
        <div className="block-title text-center">
          <div className="dot-line"></div>
          <p>Explore beautiful destinations</p>
          <h2>Our Popular Places</h2>
        </div>

        <div className="row">
          {/* Goa */}
          <div className="col-lg-4">
            <div className="single-offer-one hvr-float-shadow">
              <div className="image-block">
                <a href="#">
                  <i className="fa fa-link"></i>
                </a>

                {/* Replace with your image */}
                <img
                  src="/images/network/goa.jpg"
                  alt="Goa"
                />
              </div>

              <div className="text-block">
                <h3>
                  <a href="#">Goa</a>
                </h3>

                <p>
                  Enjoy beautiful beaches, nightlife, water sports,
                  and relaxing sunsets in Goa.
                </p>

                {/* <a href="#" className="more-link">
                  Explore More
                </a> */}
              </div>
            </div>
          </div>

          {/* Mumbai */}
          <div className="col-lg-4">
            <div className="single-offer-one hvr-float-shadow">
              <div className="image-block">
                <a href="#">
                  <i className="fa fa-link"></i>
                </a>

                {/* Replace with your image */}
                <img
                  src="/images/network/mumbai.jpg"
                  alt="Mumbai"
                />
              </div>

              <div className="text-block">
                <h3>
                  <a href="#">Mumbai</a>
                </h3>

                <p>
                  Discover the city of dreams with iconic landmarks,
                  street food, and marine drive views.
                </p>
{/* 
                <a href="#" className="more-link">
                  Explore More
                </a> */}
              </div>
            </div>
          </div>

          {/* Lonavala */}
          <div className="col-lg-4">
            <div className="single-offer-one hvr-float-shadow">
              <div className="image-block">
                <a href="#">
                  <i className="fa fa-link"></i>
                </a>

                {/* Replace with your image */}
                <img
                  src="/images/network/lonavla.jpg"
                  alt="Lonavala"
                />
              </div>

              <div className="text-block">
                <h3>
                  <a href="#">Lonavala</a>
                </h3>

                <p>
                  Experience scenic hills, waterfalls, green valleys,
                  and peaceful mountain weather.
                </p>

                {/* <a href="#" className="more-link">
                  Explore More
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfferStyleOne;